/**
 * Format a prize pool amount with commas and no trailing zeros unless there are cents.
 * e.g. 1000000 -> "$1,000,000", 1000000.50 -> "$1,000,000.50"
 */
export function formatPrizePool(amount: number | null | undefined): string {
  const num = Number(amount);
  if (Number.isNaN(num)) return '$0';
  const hasCents = num % 1 !== 0;
  const str = hasCents ? num.toFixed(2) : num.toFixed(0);
  const withCommas = str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const trimmed = withCommas.replace(/\.0+$/, '');
  return `$${trimmed}`;
}
